  import SuperAdminForm from './_form';
  import template from './new.pug';

  export default Vue.extend({
    template: template(),
    components: {
      SuperAdminForm
    },
    data() {
      return {
        lastPath: null,
        lastPathParams: {},
        errors: {}
      };
    },
    beforeRouteEnter(_to, from, next) {
      next(vm => {
        if (['super-admin-index', 'super-admin-new', 'super-admin-edit'].includes(from?.name)) {
          vm.lastPathParams = from.params;
          vm.lastPath = from.name;
        }
      });
    },
    created() {
      this.$setPageTitle(this.$t('superAdmins.new.title'));
      this.$setBreadcrumbs([
        { label: this.$t('superAdmins.breadcrumbs.index'), route: { name: 'super-admin-index' } },
        { label: this.$t('superAdmins.breadcrumbs.new'), route: {} }
      ]);
    },
    methods: {
      createSuperAdmin(data) {
        API.superAdmins.create(data).then(() => {
          this.$notifications.success(this.$t('superAdmins.new.succesfullyCreated'));
          this.$router.push({
            name: this.lastPath || 'super-admin-index',
            params: this.lastPathParams
          });
        }, errors => {
          this.errors = errors;
        });
      }
    }
  });
